// src/api/creditoSalidaEquipo.js
import { apiFetch } from './index';

/**
 * Crear múltiples cuotas de crédito asociadas a una salida de equipo
 * @param {Array} cuotas - Lista de cuotas a crear
 * @returns {Promise} Resultado de la operación
 */
export const crearCuotasSalidaEquipo = async (cuotas) => {
  try {
    // Asegurar que cada cuota tenga fecha_inicio
    const cuotasConFechaInicio = cuotas.map(c => ({
      ...c,
      fechaInicio: c.fechaInicio || c.fechaVencimiento || new Date().toISOString().split('T')[0]
    }));
    
    return await apiFetch('/CreditoSalidaEquipo/multiple', {
      method: 'POST',
      body: cuotasConFechaInicio
    });
  } catch (error) {
    console.error('❌ Error creando cuotas de salida:', error);
    throw error;
  }
};

/**
 * Obtener cuotas por ID de SalidaEquipoDetalle
 * @param {number} idSalidaEquipoDetalle 
 * @returns {Promise}
 */
export const obtenerCuotasPorSalida = async (idSalidaEquipoDetalle) => {
  try {
    return await apiFetch(`/CreditoSalidaEquipo/detalle/${idSalidaEquipoDetalle}`);
  } catch (error) {
    console.error('❌ Error obteniendo cuotas:', error);
    throw error;
  }
};

/**
 * Obtener cuotas por fecha de inicio
 * @param {string} desde - Fecha desde (YYYY-MM-DD)
 * @param {string} hasta - Fecha hasta (YYYY-MM-DD)
 * @returns {Promise}
 */
export const obtenerCuotasPorFechaInicio = async (desde, hasta) => {
  try {
    return await apiFetch(`/CreditoSalidaEquipo/fechainicio/${desde}/${hasta}`);
  } catch (error) {
    console.error('❌ Error obteniendo cuotas por fecha de inicio:', error);
    throw error;
  }
};

/**
 * Obtener total financiado hoy (mínimo) - TODAS las cuotas
 * @returns {Promise}
 */
export const obtenerFinanciadoHoyMinimo = async () => {
  try {
    return await apiFetch('/CreditoSalidaEquipo/financiado-hoy-minimo');
  } catch (error) {
    console.error('❌ Error obteniendo financiado hoy mínimo:', error);
    throw error;
  }
};

// ===================== NUEVAS FUNCIONES PARA FINANCIADO DE EQUIPOS =====================

/**
 * Obtener total financiado de equipos hoy (mínimo) - EXCLUYE crédito empresa
 * @returns {Promise} { fecha, cuotas, total, tipo }
 */
export const obtenerFinanciadoEquiposHoyMinimo = async () => {
  try {
    return await apiFetch('/CreditoSalidaEquipo/financiado-equipos-hoy-minimo');
  } catch (error) {
    console.error('❌ Error obteniendo financiado de equipos hoy mínimo:', error);
    throw error;
  }
};

/**
 * Obtener financiado de equipos para una fecha específica
 * @param {string} fecha - Fecha en formato YYYY-MM-DD
 * @returns {Promise}
 */
export const obtenerFinanciadoEquiposMinimo = async (fecha) => {
  try {
    return await apiFetch(`/CreditoSalidaEquipo/financiado-equipos-minimo/${fecha}`);
  } catch (error) {
    console.error(`❌ Error obteniendo financiado de equipos para ${fecha}:`, error);
    throw error;
  }
};

/**
 * Obtener financiado de equipos diario completo
 * @param {string} fecha - Fecha en formato YYYY-MM-DD
 * @returns {Promise}
 */
export const obtenerFinanciadoEquiposDiario = async (fecha) => {
  try {
    return await apiFetch(`/CreditoSalidaEquipo/financiado-equipos/${fecha}`);
  } catch (error) {
    console.error(`❌ Error obteniendo financiado de equipos diario para ${fecha}:`, error);
    throw error;
  }
};

/**
 * Obtener resumen de financiado de equipos
 * @param {string} fecha - Fecha en formato YYYY-MM-DD
 * @returns {Promise}
 */
export const obtenerFinanciadoEquiposResumen = async (fecha) => {
  try {
    return await apiFetch(`/CreditoSalidaEquipo/financiado-equipos-resumen/${fecha}`);
  } catch (error) {
    console.error(`❌ Error obteniendo resumen financiado de equipos para ${fecha}:`, error);
    throw error;
  }
};

export default {
  crearCuotasSalidaEquipo,
  obtenerCuotasPorSalida,
  obtenerCuotasPorFechaInicio,
  obtenerFinanciadoHoyMinimo,
  obtenerFinanciadoEquiposHoyMinimo,
  obtenerFinanciadoEquiposMinimo,
  obtenerFinanciadoEquiposDiario,
  obtenerFinanciadoEquiposResumen
};